import { render, staticRenderFns } from "./BasePushNotificationForm.vue?vue&type=template&id=95efff74&scoped=true&"
import script from "./BasePushNotificationForm.vue?vue&type=script&lang=js&"
export * from "./BasePushNotificationForm.vue?vue&type=script&lang=js&"
import style0 from "./BasePushNotificationForm.vue?vue&type=style&index=0&id=95efff74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95efff74",
  null
  
)

export default component.exports